<template>
	<o-card
		:id="`time-ticket-week-card-${setup.timeTicket.weekNumber}`"
		class="time-ticket-week-card"
		:class="{ 'time-ticket-week-card--current': setup.isCurrentWeek }"
		header-line
		@click="setup.storeScrollAndNavigate()">
		<template #header>
			<div class="week__picto">
				<o-icon font-icon="icon-interface-calendar-mark"/>
			</div>
			<div>
				<div class="week__index">{{ $t('timeTicket.week.label', { weekNumber: setup.timeTicket.weekNumber }) }}</div>
				<div class="week__dates">{{ setup.timeTicket.readableDates }}</div>
			</div>
		</template>

		<div class="week__circles">
			<time-ticket-week-circle
				color="info"
				:label="$t('timeTicket.week.toFillByTempWorker')"
				:value="setup.timeTicket.qtyPending"/>
			<time-ticket-week-circle
				color="warning-alt"
				:label="setup.timeTicket.labelToFillClient"
				:value="setup.timeTicket.qtyToValidate"/>
			<time-ticket-week-circle
				color="success"
				:label="$t('timeTicket.week.validated')"
				:value="setup.timeTicket.qtyValidated"/>
			<time-ticket-week-circle
				color="pink"
				:label="$t('timeTicket.week.integrated')"
				:value="setup.timeTicket.qtyIntegrated"/>
		</div>
	</o-card>
</template>

<script setup lang="ts">
import TimeTicketWeekCircle from '@/components/time-ticket/TimeTicketWeekCircle.vue';
// #region Setup
import type { TimeTicketWeekCardEmits, TimeTicketWeekCardProps } from './TimeTicketWeekCardSetup';
import TimeTicketWeekCardSetup from './TimeTicketWeekCardSetup';
const emits = defineEmits<TimeTicketWeekCardEmits>() as TimeTicketWeekCardEmits;
const props = withDefaults(defineProps<TimeTicketWeekCardProps>(), TimeTicketWeekCardSetup.defaultProps);
const setup = new TimeTicketWeekCardSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
@import "@/styles/mixins";

.time-ticket-week-card,
.time-ticket-week-sticker {
	.week {
		&__picto {
			.circle(3.75rem);
			.flex-align();

			margin-right: 0.9rem;
			font-size: 1.75rem;
			background-color: var(--grey-lighter);
		}

		&__index {
			font-weight: bold;
			color: var(--grey-darker);
		}

		&__dates {
			color: var(--grey);
		}

		&__percentage {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 0.9rem;
		}

		&__circles {
			display: flex;
			flex-direction: column;
			gap: 0.9rem;
			width: fit-content;
			margin: auto;
		}
	}

	&--current .week__picto {
		color: white;
		background-color: var(--info);
	}
}

.time-ticket-week-card {
	height: 100%;

	:deep(.orion-card__header) {
		display: flex;
		align-items: center;
		font-size: 0.9rem;
		line-height: 1.3rem;
	}
}
</style>
